// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".StatusCell-base__j1Opt{display:flex;gap:var(--size-1_5);align-items:center;width:var(--size-full);height:var(--size-12);padding:var(--size-0) var(--size-4);border-bottom:var(--size-px) solid var(--gray-a3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "StatusCell-base__j1Opt"
};
export default ___CSS_LOADER_EXPORT___;
